/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsNativePitrBackupPolicyPlan } from '../models/AwsNativePitrBackupPolicyPlan';
import { BackupPolicyType } from '../models/BackupPolicyType';
import { HighFrequencyBackupPolicyPlan } from '../models/HighFrequencyBackupPolicyPlan';
import { NativeStandardBackupPolicyPlan } from '../models/NativeStandardBackupPolicyPlan';
import { PitrBackupPolicyPlan } from '../models/PitrBackupPolicyPlan';
import { Provider } from '../models/Provider';
import { StandardBackupPolicyPlan } from '../models/StandardBackupPolicyPlan';

export class BackupPolicyPlan {
  'sourceCloudProvider'?: Provider;
  'backupPolicyType': BackupPolicyType;
  'standardPlan'?: StandardBackupPolicyPlan | null;
  'highFrequencyPlan'?: HighFrequencyBackupPolicyPlan | null;
  'pitrPlan'?: PitrBackupPolicyPlan | null;
  'awsNativePitrPlan'?: AwsNativePitrBackupPolicyPlan | null;
  'nativeStandardPlan'?: NativeStandardBackupPolicyPlan | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sourceCloudProvider",
      "baseName": "sourceCloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "backupPolicyType",
      "baseName": "backupPolicyType",
      "type": "BackupPolicyType",
      "format": ""
    },
    {
      "name": "standardPlan",
      "baseName": "standardPlan",
      "type": "StandardBackupPolicyPlan",
      "format": ""
    },
    {
      "name": "highFrequencyPlan",
      "baseName": "highFrequencyPlan",
      "type": "HighFrequencyBackupPolicyPlan",
      "format": ""
    },
    {
      "name": "pitrPlan",
      "baseName": "pitrPlan",
      "type": "PitrBackupPolicyPlan",
      "format": ""
    },
    {
      "name": "awsNativePitrPlan",
      "baseName": "awsNativePitrPlan",
      "type": "AwsNativePitrBackupPolicyPlan",
      "format": ""
    },
    {
      "name": "nativeStandardPlan",
      "baseName": "nativeStandardPlan",
      "type": "NativeStandardBackupPolicyPlan",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}



